import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { snakify } from '@/helpers/common';
import { isCMSV3 } from '@/helpers/conf';

export interface AvatarD {
  userId: number;
  avatarId: number;
}

export type Avatar = AvatarD & CMSApiBase;

export const getAvatarsByUserIdV3 = (userId: number) =>
  request<Avatar[]>({
    url: buildCmsUrl({
      path: 'avatars',
      additionalParams: { user_id: userId },
    }),
  });

export const getAvatarsByUserIdV4 = (userId: number) =>
  request<Avatar[]>({
    url: buildCmsUrl({
      path: 'avatars',
      additionalParams: { 'filters[user_id][$eq]': userId },
    }),
    transformResponse: pipe(getResponseCamelization, getResponseCMS<Avatar[]>),
  });

export const getAvatarsByUserId = isCMSV3
  ? getAvatarsByUserIdV3
  : getAvatarsByUserIdV4;

export const createUserAvatarV3 = (summary: AvatarD) =>
  request<Avatar>({
    method: 'POST',
    url: buildCmsUrl({ path: 'avatars' }),
    data: snakify(summary),
  });

export const createUserAvatarV4 = (summary: AvatarD) =>
  request<Avatar>({
    method: 'POST',
    url: buildCmsUrl({ path: 'avatars' }),
    data: snakify({ data: summary }),
  });

export const createUserAvatar = isCMSV3
  ? createUserAvatarV3
  : createUserAvatarV4;

export const updateUserAvatarV3 = async (fieldId: number, summary: AvatarD) =>
  request<Avatar>({
    method: 'PUT',
    url: buildCmsUrl({ path: `avatars/${fieldId}` }),
    data: snakify(summary),
  });

export const updateUserAvatarV4 = async (fieldId: number, summary: AvatarD) =>
  request<Avatar>({
    method: 'PUT',
    url: buildCmsUrl({ path: `avatars/${fieldId}` }),
    data: snakify({ data: summary }),
  });

export const updateUserAvatar = isCMSV3
  ? updateUserAvatarV3
  : updateUserAvatarV4;

export const deleteAvatarByUserId = async (fieldId: number) =>
  request<Avatar>({
    method: 'DELETE',
    url: buildCmsUrl({ path: `avatars/${fieldId}` }),
  });
